var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternet1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 2.31389C70.1107 2.31389 89.6862 21.9356 89.6862 46C89.6862 70.0645 70.0644 89.6862 46 89.6862C21.9356 89.6862 2.31388 70.0645 2.31388 46C2.31388 21.9356 21.9356 2.31389 46 2.31389ZM46 0C20.5936 0 0 20.5936 0 46C0 71.4065 20.5936 92.0001 46 92.0001C71.4065 92.0001 92.0001 71.4065 92.0001 46C92.0464 20.5936 71.4528 0 46 0Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 88.0198C69.2071 88.0198 88.0201 69.2067 88.0201 45.9997C88.0201 22.7926 69.2071 3.97949 46 3.97949C22.7929 3.97949 3.9798 22.7926 3.9798 45.9997C3.9798 69.2067 22.7929 88.0198 46 88.0198Z",
    fill: "url(#paint0_radial_531_19319)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_19319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8617 48.7539C52.8229 48.7539 48.7235 52.8533 48.7235 57.8922C49.1829 69.9988 66.5425 69.9953 67.0001 57.8921C67 52.8533 62.9006 48.7539 57.8617 48.7539ZM60.5956 60.6261C60.1151 61.1067 59.3361 61.1067 58.8555 60.6261L57.8617 59.6323L56.8679 60.6261C56.3874 61.1067 55.6083 61.1067 55.1278 60.6261C54.6472 60.1456 54.6472 59.3665 55.1278 58.886L56.1216 57.8922L55.1278 56.8984C54.6472 56.4178 54.6472 55.6388 55.1278 55.1582C55.6083 54.6777 56.3874 54.6777 56.8679 55.1582L57.8617 56.152L58.8555 55.1582C59.3361 54.6776 60.1151 54.6776 60.5956 55.1582C61.0762 55.6387 61.0762 56.4178 60.5956 56.8983L59.6018 57.8921L60.5956 58.8859C61.0762 59.3665 61.0762 60.1456 60.5956 60.6261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8534 45.5404C52.6448 49.0647 57.9053 43.8124 54.3787 40.0151C48.6723 34.3088 39.4204 34.3088 33.7141 40.0151C32.1883 41.5409 32.1883 44.0146 33.7141 45.5404C35.2399 47.0662 37.7136 47.0662 39.2394 45.5404C41.8942 42.8855 46.1985 42.8855 48.8534 45.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4231 37.9708C60.2093 41.494 65.477 36.246 61.9483 32.4455C52.0613 22.5585 36.0313 22.5585 26.1443 32.4455C24.6186 33.9713 24.6186 36.445 26.1443 37.9708C27.6701 39.4966 30.1439 39.4966 31.6696 37.9708C38.5051 31.1353 49.5876 31.1353 56.4231 37.9708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0464 46.4404C41.8886 46.4404 40.1394 48.1897 40.1394 50.3474C40.3309 55.5243 47.7625 55.5229 47.9533 50.3473C47.9533 48.1897 46.2041 46.4404 44.0464 46.4404Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_531_19319",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9999 45.9996) rotate(-90) scale(42.0202 41.5124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_19319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet1);
export default __webpack_public_path__ + "static/media/no-internet1.744cfdc671784adcdda633f433958730.svg";
export { ForwardRef as ReactComponent };